import React from 'react'

const Button = ({ text, svg, background, onClick, disabled = false }) => {
  return (
    <button
      type='button'
      className='bahceButton'
      style={{
        background: background,
        opacity: disabled ? 0.7 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <div>{svg}</div>
      <div>{text}</div>
    </button>
  )
}

export default Button
